/**
 * Generates className for a grid row cell based on its state
 *
 * @param {Function} checkFieldChanged - Function to check if field has changed
 * @param {Object} rowData - The row data object
 * @returns {string} CSS class names for the row
 */
export const getRowClassName = (checkFieldChanged, rowData) => {
    const classes = []

    if (checkFieldChanged(rowData)) {
        classes.push('changed-field')
    }

    if (rowData.isDeleted) {
        classes.push('pending-deletion')
    }

    return classes.join(' ')
}
